module.exports = __webpack_public_path__ + "media/images/photo/plans/shooting-spots/shooting-spot-tokai-3-f7862c8969aac2b45e7667eb1d568f45.png";